/* eslint-disable */
function extractOption(fieldOptions, key) {
    if (!fieldOptions[key]) {
        return [{ value: null, text: `No Data` }]
    }
    return [...fieldOptions[key].map(option => {
        return {
            value: option.id,
            text: option.label
        }
    })]
}

export default {
    recipeValidationRules: () => {
        return {
            "title": {
                presence: true,
                length: {
                    minimum: 1,
                    message: "can't be blank",
                }
            },
            "description": {
                presence: true,
                length: {
                    minimum: 1,
                    message: "can't be blank",
                }
            },
            "categories": {
                presence: true,
                length: {
                    minimum: 1,
                    message: "can't be blank",
                }
            },
        }
    },
    fieldOptionsChunked: (state) => {
        return state.fieldOptions
    },
    mealTimeOptions: (state) => {
        return extractOption(state.fieldOptions, 'MLT')
    },
    categoriesFieldOptions: (state) => {
        return extractOption(state.fieldOptions, 'CAT')
    },
    dietaryPreferencesOptions: (state) => {
        return extractOption(state.fieldOptions, 'DTP')
    },
    goalOptions: (state) => {
        return extractOption(state.fieldOptions, 'GOAL')
    },
    effectsOptions: (state) => {
        return extractOption(state.fieldOptions, 'EFFECTS')
    },
    intentionsOptions: (state) => {
        return extractOption(state.fieldOptions, 'INTENTIONS')
    },
    skillLevelOptions: (state) => {
        return extractOption(state.fieldOptions, 'SKILL_LEVEL')
    },
    storageOptions: (state) => {
        return extractOption(state.fieldOptions, 'STORAGE')
    },
    recipes: (state) => {
        return state.recipeList
    },
    ingredients: (state) => {
        return state.ingredients.map(ingredient => {
            return {
                value: ingredient.id,
                text: ingredient.name,
                image: ingredient.image,
                unit: ingredient.unit,
                unit_name: ingredient.unit_name,
            }
        })
    },
    units: (state) => {
        return state.units.map(unit => {
            return {
                text: unit.name,
                value: unit.id
            }
        })
    },
    showIngredientsModal: (state) => {
        return state.showIngredientsModal
    },
    categoriesOptions: (state) => {
        return state.categories.map(category => {
            return {
                text: category.name,
                value: category.id
            }
        })
    },
    ingredientGroups(state) {
        return state.currentRecipe.ingredient_groups
    },
    currentRecipe: (state) => {

        const recipe = JSON.parse(JSON.stringify(state.currentRecipe))
   

        recipe.ingredient_groups = recipe.ingredient_groups.map((group, index) => {
            return {
                ...group, 
                position: index+1
            }
        })

        recipe.instruction_groups = recipe.instruction_groups.map((group, index) => {
            return {
                ...group, 
                position: index+1
            }
        })

        return recipe
    },
    recipeErrors: (state) => {
        return state.currentRecipeErrors
    },
    currentIngredient: (state) => {
        return state.currentIngredient
    },
    currentIngredientMode: (state) => {
        return state.currentIngredientMode
    },
    ingredientItemNumericQuantityOptions: (state) => {
        return state.ingredientItemNumericQuantity.map(numeric => {
            return {
                text: numeric.numeric_representation,
                value: numeric.value
            }
        })
    },
    dietaryOptions: (state) => {
        return [...state.dietaryOptions.map(option => {
            return {
                value: option.id,
                text: option.label
            }
        })]
    },

    usersOptions: (state) => {
        return [...state.users.map(option => {
            if (option.profile == 'Sam Gowing')
                return {
                    value: option.profile,
                    text: option.profile
                }
        })]
    },
    recipesOptions: (state) => {
        return [...state.recipesOptions.map(option => {
            return {
                value: option.id,
                text: option.title
            }
        })]
    },
    tabStatus: (state) => {
        return state.tabStatus
    },
}